module.exports = __webpack_public_path__ + "static/img/a058.bc7a03c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a058.jpg
// module id = pnG5
// module chunks = 0